// Polyfill for window.Element.closest()
// get nearest parent element matching selector
const closest = (el, selector) => {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if(matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
};

export default closest;



// WEBPACK FOOTER //
// ./src/app/mixins/closest.js